import styled from 'styled-components'

 

export const LinkButton = styled.button`

     //layout 
     display: inline-block;
       
     //content 
     line-height: 1;
     text-align: left;

     //box-model 
     border: none; 
     font-size:  inherit;
     font-weight: 300; 

     //size 
     width: auto;
     background-color: transparent; 
 

     //animation 
     cursor: pointer;
      
`

 